
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/guides/localization",
      function () {
        return require("private-next-pages/material-ui/guides/localization.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/guides/localization"])
      });
    }
  